import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext.jsx';
import { generateStudy, extractProfile } from '../services/anthropic.js';

// Renders a loading UI while the first day is generated using the
// user's intake + Enneagram results (already on userProfile by the
// time the user reaches /preparing). Navigates directly to /study/day/1
// once AppContext.study lands. The legacy /profile-on-mount redirect
// is gone — Mike's redesigned funnel routes Preparing → Day 1.
export default function Preparing() {
  const navigate = useNavigate();
  const { study, userProfile, intakeMessages, guide, setStudy } = useApp();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;

    (async () => {
      try {
        // Extract structured profile fields (name, faith_background,
        // life_season, primary_pain_point, focus_areas) from the intake
        // transcript as a defensive fallback for intakes where the
        // guide skipped the CRITICAL OPENING RULE and the name wasn't
        // captured directly.
        const extracted = await extractProfile(intakeMessages || [], guide);
        // userProfile fields take precedence over extracted — extractProfile serves
        // only as a fallback for missing values (e.g., if intake skipped the name
        // capture). Assessment-measured Enneagram, user-confirmed name, and any other
        // canonical userProfile fields always win.
        const profile = {
          ...extracted,
          ...Object.fromEntries(
            Object.entries(userProfile || {}).filter(
              ([_, v]) => v != null && v !== ''
            )
          ),
        };
        const result = await generateStudy(profile, intakeMessages || []);
        setStudy(result);
      } catch (e) {
        console.error('[Preparing] study generation failed:', e);
        // Leave hasStarted true to prevent retry loops; user can
        // refresh or navigate back manually.
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (study) {
      navigate('/study/day/1', { replace: true });
    }
  }, [study, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '24px',
        textAlign: 'center',
        background: '#F2EBDC',
      }}
    >
      <p
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: '20px',
          fontStyle: 'italic',
          color: '#1B1814',
          maxWidth: '480px',
          margin: 0,
        }}
      >
        Building your first day…
      </p>
      <p
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: '14px',
          color: '#1B1814',
          opacity: 0.55,
          marginTop: '12px',
        }}
      >
        This usually takes about a minute.
      </p>
    </div>
  );
}
